import * as React from "react";
import { AccordionContent } from "../../accordion/accordion-content/accordion-content.mjs";
import { AccordionHeader } from "../../accordion/accordion-header/accordion-header.mjs";
import { AccordionItem } from "../../accordion/accordion-item/accordion-item.mjs";
import { AccordionTitle } from "../../accordion/accordion-title/accordion-title.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Tooltip } from "../../tooltip/tooltip.mjs";
import { TooltipToggle } from "../../tooltip-toggle/tooltip-toggle.mjs";
import { FilterContext } from "../filter/filter-context.mjs";
const FilterSection = (props) => {
  const { id, title, children, tooltip, defaultIsOpen = false, isOpen: propOpen, onToggle, purpose } = props;
  const [openState, setOpenState] = React.useState(defaultIsOpen);
  const context = React.useContext(FilterContext);
  const sectionPurpose = purpose ? purpose : context.purpose;
  const isEmployee = sectionPurpose === "employee";
  const isOpen = propOpen !== void 0 ? propOpen : openState;
  const handleToggle = (nextOpen) => {
    if (propOpen === void 0) {
      setOpenState(nextOpen);
    }
    if (onToggle) {
      onToggle(nextOpen);
    }
  };
  const renderTooltip = (tooltip2, id2) => /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      referenceElement: /* @__PURE__ */ React.createElement(TooltipToggle, { id: id2 + "-tooltip-toggle", icon: true, color: isEmployee ? "employee" : void 0 }, tooltip2.label)
    },
    tooltip2.content
  );
  return /* @__PURE__ */ React.createElement(AccordionItem, { id, type: isEmployee ? "employee" : void 0, background: "transparent", isOpen, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(AccordionHeader, null, /* @__PURE__ */ React.createElement(Grid, { gutter: "xsmall" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(AccordionTitle, null, title)), /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, tooltip && renderTooltip(tooltip, id)))), /* @__PURE__ */ React.createElement(AccordionContent, null, children));
};
export {
  FilterSection
};
